import './FormControlLeadingVisual-e217df71.css';

var classes = {"LeadingVisual":"prc-FormControl-LeadingVisual-Gycks"};

export { classes as default };
